import * as React from 'react';

import {DropdownButton} from 'shells/button/dropdown-button/dropdown-button';
import {Popover} from 'shells/popover/popover';
import {RangeInput} from 'shells/range-input/range-input';

import {TwoLineInfo} from './two-line-info';

import styles from './lead-confidence.module.css';

type Props = {
    value: number;
    onUpdate: (arg1: number) => void;
};

type State = {
    showConfidenceSlider: boolean;
    leadConfidence: number;
};

export class LeadConfidence extends React.PureComponent<Props, State> {
    confidenceRef: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            showConfidenceSlider: false,
            leadConfidence: props.value,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        // If we didn't have a lead props, and now we do (it was loaded), or if
        // the lead confidence differs, load it into state. This is needed so
        // we can just update the confidence only once when its changed.
        if (nextProps.value !== this.props.value) {
            this.setState({
                leadConfidence: nextProps.value,
            });
        }
    }

    render() {
        return (
            <TwoLineInfo
                header='Confidence'
                body={
                    <React.Fragment>
                        <div
                            ref={(ref) => (this.confidenceRef = ref)}
                            className={styles['confidence-container']}
                        >
                            <DropdownButton
                                label={`${this.state.leadConfidence}%`}
                                onClick={() => {
                                    this.setState({showConfidenceSlider: true});
                                }}
                            />
                        </div>
                        {this.state.showConfidenceSlider ? (
                            <Popover
                                location='bottom'
                                onBlur={this.handleConfidencePopupBlur}
                                anchor={this.confidenceRef}
                            >
                                <div className={styles['confidence-slider-container']}>
                                    <RangeInput
                                        value={this.state.leadConfidence}
                                        onChange={(value) => {
                                            this.setState({leadConfidence: value});
                                        }}
                                    />
                                </div>
                            </Popover>
                        ) : undefined}
                    </React.Fragment>
                }
            />
        );
    }

    handleConfidencePopupBlur = () => {
        this.setState({showConfidenceSlider: false});
        this.props.onUpdate(this.state.leadConfidence);
    };
}
